<div class="valgte-filer">
  <p>
    @if (visRegistrerNyeVersjonsBekreftelse()) {
      {{ 'Dokumenter valgt for import:'|translate }}
    } @else {
      {{ 'Laster opp dokumenter:'|translate }}
    }
  </p>
  @for (valgtFil of filerUnderOpplasting(); track valgtFil) {
    <div class="fil">
      <div class="status">
        @if (valgtFil.lastetOpp || visRegistrerNyeVersjonsBekreftelse()) {
          <i class="ion-ios-checkmark-outline ferdig"></i>
        } @else if (valgtFil.feilet) {
          <i class="ion-alert-circled feilet"></i>
        } @else {
          <mat-progress-spinner mode="indeterminate" diameter="15"/>
        }
      </div>
      <span>{{ valgtFil.fil.filnavn }}</span>
      @if (valgtFil.feilet) {
        <span class="feilmelding">
          - {{ 'opplasting feilet'|translate }}
        </span>
      }
    </div>
  }
</div>

@if (visRegistrerNyeVersjonsBekreftelse()) {
  <inline-melding>
    <p>{{ 'Følgende dokumenter eksisterer allerede, vil du registrere disse som nye versjoner?'|translate }}</p>
    <ul>
      @for (fil of nyeVersjoner(); track fil.filnavn) {
        <li>{{ fil.filnavn }}</li>
      }
    </ul>
    <button type="button" mat-raised-button color="primary" (click)="startOpplasting()">{{ 'Registrer ny versjon'|translate }}
    </button>
  </inline-melding>
}

@if (modus() != 'opplastingFeilet') {
  <div class="avbryt">
    <button type="button" mat-button color="primary" (click)="avbrytLastOpp()">{{ 'Avbryt'|translate }}</button>
  </div>

} @else {
  <inline-melding type="advarsel">
    <p>{{ 'Opplasting av enkelte dokumenter feilet'|translate }}</p>
    <button type="button" mat-raised-button (click)="lukk()">{{ 'Ok'|translate }}
    </button>
  </inline-melding>
}


